import { showNotification } from '../store/actions/notificationActions'


export const handleValidations = error => {
  return showNotification('error', error.message)
}
